import React from 'react';
import { Clock, Plus } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import SectionTitle from '../../SectionTitle';
import { Duration, formatDuration } from '@/lib/timeCalculations';

/**
 * Header component for PlanEditor
 * 
 * Displays:
 * - Title with icon
 * - Total duration of all hendelser
 * - "Add overskrift" button
 * 
 * Extracted from PlanEditor.tsx for better modularity.
 */

interface PlanEditorHeaderProps {
  totalDuration: Duration;
  hasHendelser: boolean;
  onAddOverskrift: () => void;
  readOnly?: boolean;
}

export const PlanEditorHeader: React.FC<PlanEditorHeaderProps> = ({
  totalDuration,
  hasHendelser,
  onAddOverskrift,
  readOnly = false,
}) => {
  return (
    <>
      {/* Title and total duration */}
      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-3">
        <SectionTitle icon={Clock}>Produksjonsplan</SectionTitle>
        
        {hasHendelser && (
          <div className="flex items-center gap-2">
            <span className="text-xs sm:text-sm text-muted-foreground">Total varighet:</span>
            <Badge 
              variant="outline"
              className="gap-1 text-xs sm:text-sm font-semibold bg-primary/10 text-primary border-primary/30"
            >
              <Clock className="h-3 w-3 sm:h-4 sm:w-4" />
              {formatDuration(totalDuration)}
            </Badge>
          </div>
        )}
      </div>

      {/* Add overskrift button */}
      {!readOnly && (
        <div>
          <Button
            onClick={onAddOverskrift}
            size="sm"
            className="gap-2 w-full sm:w-auto"
          >
            <Plus className="h-4 w-4 sm:h-5 sm:w-5" />
            <span className="text-xs sm:text-sm">Legg til overskrift</span>
          </Button>
        </div>
      )}
    </>
  );
};

